/** A backend DocumentType enum számértékei - ezekkel kell egyeznie. */
export enum DocumentType {
  Medical = 0,
  RegistrationForm = 1,
  Photo = 2,
  MedicalCertificate = 3,
  TransferDocument = 4,
  Contract = 5,
  ExcuseLetter = 6,
  Other = 7,
  AbsenceCertificate = 8,
  PeExemption = 9,
}

export interface Document {
  id: number;
  fileName: string;
  originalFileName: string;
  contentType: string;
  fileSize: number;
  type: DocumentType;
  description?: string;
  uploadedAt: string;
  uploadedByUserId: number;
  uploadedByUserName: string;
  playerId?: number;
  playerName?: string;
  userId?: number;
  userName?: string;
  isPublic: boolean;
  /** Mikor küldték el utoljára a játékos iskolájának. */
  sentToSchoolAt?: string | null;
  sentToSchoolEmail?: string | null;
}

export interface DocumentListItem {
  entityId: number;
  name: string;
  documentCount: number;
  ageGroups?: string;
}

export interface UploadDocumentRequest {
  type: DocumentType;
  description?: string;
  playerId?: number;
  userId?: number;
  isPublic: boolean;
}
